import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Profile/Index.vue";
import store from "@/store/index.js";

Vue.use(VueRouter);
const refCode = localStorage.getItem("refcode");
const THEME = process.env.VUE_APP_USE_THEME;

const LandingPageComponent =
  refCode == "moph" || THEME === "MOPH" || THEME === "MOPH_ADMIN"
    ? () => import("../views/LandingPage/LandingPageMoph.vue")
    : refCode == "kku" || THEME == "KKU_ADMIN"
    ? () => import("../views/LandingPage/LandingPageKKU.vue")
    : refCode === "niems" || THEME === "NIEMS_ADMIN"
    ? () => import("../views/LandingPage/LandingPageNIEMS.vue")
    : THEME === "NIEMS_TRAINING_ADMIN"
    ? () => import("../views/LandingPage/LandingPageTraining.vue")
    : refCode === "spu" || THEME === "SPU_ADMIN"
    ? () => import("../views/LandingPage/LandingPageSPU.vue")
    : refCode === "spu" || THEME === "SUT_ADMIN"
    ? () => import("../views/LandingPage/LandingPageSUT.vue")
    : refCode === "psu" || THEME === "PSU_ADMIN"
    ? () => import("../views/LandingPage/LandingPagePSU.vue")
    : refCode === "swu" || THEME === "SWU_ADMIN"
    ? () => import("../views/LandingPage/LandingPageSWU.vue")
    : () => import("../views/LandingPage/LandingPage.vue");

const NavbarPageComponent =
  refCode == "moph" || THEME === "MOPH" || THEME === "MOPH_ADMIN"
    ? () => import("../layout/Nav-bar-MOPH.vue")
    : refCode === "kku" || THEME == "KKU_ADMIN"
    ? () => import("../layout/Nav-bar-KKU.vue")
    : THEME === "UTCC_JOBFAIR_ADMIN"
    ? () => import("../views/LandingPage/LandingPageJobFair.vue")
    : refCode === "spu" || THEME === "SPU_ADMIN"
    ? () => import("../layout/Nav-bar-SPU.vue")
    : refCode === "sut" || THEME === "SUT_ADMIN"
    ? () => import("../layout/Nav-bar-SUT.vue")
    : refCode === "psu" || THEME === "PSU_ADMIN"
    ? () => import("../layout/Nav-bar-PSU.vue")
    : refCode === "psu" || THEME === "SWU_ADMIN"
    ? () => import("../layout/Nav-bar-SWU.vue")
    : () => import("../layout/Nav-bar.vue");

const metatitle =
  THEME === "UTCC_JOBFAIR_ADMIN"
    ? "Admin TCC Job Fair"
    : THEME === "KKU_ADMIN"
    ? "Admin KKU Career X"
    : THEME === "SPU_ADMIN"
    ? "Admin SPUKK Career"
    : THEME === "SUT_ADMIN"
    ? "Admin SUT Career"
    : refCode === "moph" || THEME === "MOPH" || THEME === "MOPH_ADMIN"
    ? "Admin Workspace MOPH"
    : refCode === "niems" || THEME === "NIEMS_ADMIN"
    ? "Admin NIEMS"
    : THEME === "NIEMS_TRAINING_ADMIN"
    ? "Admin NIEMS Training"
    : THEME === "PSU_ADMIN"
    ? "Admin PSU Career"
    : THEME === "SWU_ADMIN"
    ? "Admin SWU Career"
    : "Admin Work Life Cycle";

const metalogo =
  THEME === "UTCC_JOBFAIR_ADMIN"
    ? require("@/assets/UtccJobFair/Meta_UTCC_JOBFAIR.png")
    : THEME === "KKU_ADMIN"
    ? require("@/assets/Meta_KKU.png")
    : THEME === "SPU_ADMIN"
    ? require("@/assets/Logo_SPU.png")
    : THEME === "SUT_ADMIN"
    ? require("@/assets/Logo_SUT.png")
    : THEME === "PSU_ADMIN"
    ? require("@/assets/logo_psu.png")
    : THEME === "SWU_ADMIN"
    ? require("@/assets/swu_logo.png")
    : refCode === "moph" || THEME === "MOPH" || THEME === "MOPH_ADMIN"
    ? require("@/assets/logo_MOPH.png")
    : refCode === "niems" ||
      THEME === "NIEMS_ADMIN" ||
      THEME === "NIEMS_TRAINING_ADMIN"
    ? require("@/assets/logo_NIEMS.png")
    : require("@/assets/nav-icon.png");

const routes = [
  {
    path: "/",
    name: "",
    component: NavbarPageComponent,
    children: [
      {
        path: "",
        name: "LandingPage",
        component: LandingPageComponent,
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    props: (route) => ({
      refcode: { ...route.query },
    }),
    meta: {
      title: metatitle,
      icon: metalogo,
    },
  },
  // {
  //   path: "/login",
  //   name: "",
  //   component: () => import("../layout/Main-login.vue"),
  //   children: [
  //     {
  //       path: "/",
  //       name: "Login",
  //       component: () => import("../views/Login.vue"),
  //       meta: {
  //         title: metatitle,
  //         icon: metalogo,
  //       },
  //     },
  //   ],
  //   meta: {
  //     title: metatitle,
  //     icon: metalogo,
  //   },
  // },
  {
    path: "/adminRef",
    name: "Loginbysharetoken",
    component: () => import("../layout/Main-login.vue"),
    meta: {
      title: metatitle,
      icon: metalogo,
    },
    props: (route) => ({
      sharetoken: { ...route.query },
    }),
  },
  // },
  {
    path: "/landing",
    name: "Loginbysharetoken",
    component: () => import("../layout/Main-login.vue"),
    meta: {
      title: metatitle,
      icon: metalogo,
    },
    props: (route) => ({
      sharetoken: { ...route.query },
    }),
  },
  {
    path: "/oauth_provider",
    name: "LoginbyProvider",
    component: () => import("../layout/Oauth-Provider.vue"),
    meta: {
      title: metatitle,
      icon: metalogo,
    },
    props: (route) => ({
      code: { ...route.query },
    }),
  },
  {
    path: "/oauth_login_kku",
    name: "LoginbyCodeKKU",
    component: () => import("../layout/Main-login-KKU.vue"),
    meta: {
      title: metatitle,
      icon: metalogo,
    },
    props: (route) => ({
      sharetoken: { ...route.query },
    }),
  },
  {
    path: "/oauth_logout_kku",
    name: "LoginbyCodeKKU",
    component: () => import("../layout/Main-logout-KKU.vue"),
  },
  {
    path: "/oauth_login_training",
    name: "loginByShareTraining",
    component: () => import("../layout/Main-login-Training.vue"),
    meta: {
      title: metatitle,
      icon: metalogo,
    },
    props: (route) => ({
      query: { ...route.query },
    }),
  },
  {
    path: "/surveyRef",
    name: "surveyRef",
    component: () => import("../views/Survey/SurveyRef.vue"),
    meta: {
      title: metatitle,
      icon: metalogo,
    },
    props: (route) => ({
      sharetoken: { ...route.query },
    }),
  },

  // {
  //   path: "/register",
  //   name: "",
  //   component: () => import("../layout/Main.vue"),
  //   children: [
  //     {
  //       path: "",
  //       name: "RegisterONEID",
  //       component: () => import('../views/Registry/RegisterOneID.vue'),
  //       meta: {
  //         title: metatitle,
  //         icon: metalogo,
  //       },
  //     },
  //   ],
  //   meta: {
  //     title: metatitle,
  //     icon: metalogo,
  //   },
  // },
  {
    path: "/register",
    name: "RegisterONEID",
    component: () => {
      if (process.env.VUE_APP_USE_THEME === "KKU_ADMIN") {
        return import("../views/Registry/RegisterOneIDKKU.vue");
      } else if (process.env.VUE_APP_USE_THEME === "SPU_ADMIN") {
        return import("../views/Registry/RegisterOneSPU.vue");
      } else if (process.env.VUE_APP_USE_THEME === "SUT_ADMIN") {
        return import("../views/Registry/RegisterOneSUT.vue");
      } else if (process.env.VUE_APP_USE_THEME === "PSU_ADMIN") {
        return import("../views/Registry/RegisterOnePSU.vue");
      }
      return import("../views/Registry/RegisterOneID.vue");
    },
    props: (route) => ({
      refcode: { ...route.query },
    }),
    meta: {
      title: metatitle,
      icon: metalogo,
    },
  },

  {
    path: "/terms",
    name: "TermsOfService",
    component: () => {
      if (THEME === "WLC_ADMIN") {
        return import("@/termandpolicy/TermsV2.vue");
      } else if (THEME === "UTCC_JOBFAIR_ADMIN") {
        return import("@/termandpolicy/TermsJobfair.vue");
      } else if (THEME === "NIEMS_ADMIN") {
        return import("@/termandpolicy/TermsNiems.vue");
      } else {
        return import("@/termandpolicy/Terms.vue");
      }
    },
    props: (route) => ({
      refcode: { ...route.query },
    }),
    meta: {
      title: "Terms of Service",
      icon: metalogo,
    },
  },
  {
    path: "/policy",
    name: "PrivacyPolicy",
    component: () => {
      if (THEME === "WLC_ADMIN") {
        return import("@/termandpolicy/PolicyV3.vue");
      } else {
        return import("@/termandpolicy/Policy.vue");
      }
    },
    props: (route) => ({
      refcode: { ...route.query },
    }),
    meta: {
      title: "Privacy Policy",
      icon: metalogo,
    },
  },
  {
    path: "/business_register",
    name: "",
    component: () => import("../layout/Main.vue"),
    children: [
      {
        path: "/",
        name: "businessregister",
        component: () => import("../views/Registry/RegisterBusiness.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/business_edit",
    name: "",
    component: () => import("../layout/Main.vue"),
    children: [
      {
        path: "/",
        name: "business_edit",
        component: () => import("../views/Registry/RegisterBusiness.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/business_add",
    name: "",
    component: () => import("../layout/Main.vue"),
    children: [
      {
        path: "/",
        name: "business_add",
        component: () => import("../views/Registry/RegisterBusiness.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  // {
  //   path: "/home",
  //   name: "",
  //   component: () => import("../layout/Main.vue"),
  //   children: [
  //     {
  //       path: "",
  //       name: "selectprofile",
  //       component: () => import("../views/SelectProfile.vue"),
  //       meta: {
  //         title: metatitle,
  //         icon: metalogo,
  //       },
  //     },
  //   ],
  //   meta: {
  //     requiresAuth: true,
  //     title: metatitle,
  //     icon: metalogo,
  //   },
  // },
  // home v2 version wlc phase 5.2
  {
    path: "/home",
    name: "",
    component: () => import("../layout/MainMoph.vue"),
    children: [
      {
        path: "",
        name: "SelectProfileV2",
        component: () => import("../views/SelectProfile/SelectProfileV2.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/home_moph",
    name: "",
    component: () => import("../layout/MainMoph.vue"),
    children: [
      {
        path: "",
        name: "SelectProfileMoph",
        component: () => import("../views/Moph/SelectProfile.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/profile_moph",
    name: "",
    component: () => import("../layout/MainMoph.vue"),
    children: [
      {
        path: "",
        name: "ProfileMoph",
        component: () => import("../views/ProfileMoph/ProfileMoph.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },

  {
    path: "/allbusiness",
    name: "",
    component: () => import("../layout/MainMoph.vue"),
    children: [
      {
        path: "",
        name: "AllBusinessPage",
        component: () => import("../views/Moph/AllBusinessPage.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/business_profile",
    name: "",
    component: () => {
      const refCode = localStorage.getItem("refcode");
      const roles = localStorage.getItem("roles");

      if (refCode === "moph") {
        return import("../layout/MainMoph.vue");
      } else if (roles == 9) {
        return import("../layout/Main-Admin-KKU.vue");
      } else {
        return import("../layout/Main.vue");
      }
    },
    children: [
      {
        path: "/",
        name: "businessprofile",
        component: Home,
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "edit_business_profile",
        name: "editbusinessprofile",
        component: () => {
          if (refCode === "moph") {
            return import("../views/EditProfile/EditProfileMoph.vue");
          } else {
            return import("../views/EditProfile/EditProfile.vue");
          }
        },
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "edit_map/:id",
        name: "EditProfileAddressMap",
        component: () =>
          import(
            "@/components/BusinessProfile/Profile/ProfileAddressMapEdit.vue"
          ),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "add_map",
        name: "AddProfileAddressMap",
        component: () =>
          import(
            "@/components/BusinessProfile/Profile/ProfileAddressMapAdd.vue"
          ),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "media",
        name: "imageandvideo",
        component: () => import("@/components/ImageAndVideo/ImageAndVideo.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "create_news",
        name: "createnews",
        component: () => import("../views/EditNew/EditNew.vue"),
        meta: {
          requiresAuth: true,
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "edit_news/:business_id/:news_id",
        name: "editnews",
        component: () => import("../views/EditNew/EditNew.vue"),
        meta: {
          requiresAuth: true,
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/work",
    name: "",
    component: () => {
      const refCode = localStorage.getItem("refcode");
      const roles = localStorage.getItem("roles");

      if (refCode === "moph") {
        return import("../layout/MainMoph.vue");
      } else if (roles == 9) {
        return import("../layout/Main-Admin-KKU.vue");
      } else {
        return import("../layout/Main.vue");
      }
    },
    children: [
      {
        path: "/",
        name: "Work",
        component: () => import("../views/Work/Work.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "create",
        name: "WorkCreate",
        component: () => import("../views/Work/WorkCreate.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "create_job",
        name: "CreateJob",
        component: () => import("../views/WorkMoph/JobForm.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "edit_job/:id?",
        name: "EditFormJob",
        component: () => import("../views/WorkMoph/JobForm.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "edit_draft",
        name: "EditDraftFormJob",
        component: () => import("../views/WorkMoph/JobForm.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "preview",
        name: "WorkPreview",
        component: () => import("../views/Work/WorkPreview.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },

      {
        path: "preview/candidate_profile",
        name: "work-preview-candidateProfile",
        component: () => import("../views/UtccJobfair/CandidateProfile.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "preview_moph",
        name: "WorkPreview",
        component: () => import("../views/Work/JobPreview.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "preview_user_candidate",
        name: "WorkPreview",
        component: () =>
          import("../views/PreviewCandidate/PreviewCandidate.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "job_applicant",
        name: "WorkJobApplicant",
        component: () => import("../views/Work/WorkJobApplicant.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "job_applicant/candidate_profile",
        name: "work-candidateProfile",
        component: () => import("../views/UtccJobfair/CandidateProfile.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "job_applicant/resume",
        name: "DialogResumeApplicant",
        component: () => import("../views/Work/DialogResumeApplicant.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "candidates_tracking",
        name: "CandidatesTracking",
        component: () => import("../views/CandidatesTrack/CandidatesTrack"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/workpart",
    name: "",
    component: () => {
      const refCode = localStorage.getItem("refcode");
      if (refCode === "moph") {
        return import("../layout/MainMoph.vue");
      } else {
        return import("../layout/Main.vue");
      }
    },
    children: [
      {
        path: "/",
        name: "WorkFairoo",
        component: () => import("../views/WorkFairoo/Work.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "create",
        name: "CreateWorkPart",
        component: () => import("../views/WorkFairoo/WorkPartCreate.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "detail",
        name: "WorkPartDetail",
        component: () => import("../views/WorkFairoo/WorkpartDetail.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "edit",
        name: "WorkPartEdit",
        component: () => import("../views/WorkFairoo/WorkPartEdit.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/writer_search",
    name: "",
    component: () => import("../layout/Main.vue"),
    children: [
      {
        path: "/",
        name: "WriterSearch",
        component: () => import("../views/WriterSearch/WriterSearch.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "detail",
        name: "WriterDetail",
        component: () => import("../views/WriterSearch/WriterDetail.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/health-rider",
    name: "",
    component: () => {
      const refCode = localStorage.getItem("refcode");
      if (refCode === "moph") {
        return import("../layout/MainMoph.vue");
      } else {
        return import("../layout/Main.vue");
      }
    },
    children: [
      {
        path: "",
        name: "WorkHealthRider",
        component: () => import("../views/HealthRider/WorkHealthRider.vue"),
      },
      {
        path: "create",
        name: "CreateWorkHealthRider",
        component: () => import("../views/HealthRider/ManageWork.vue"),
      },
      {
        path: "edit/:id",
        name: "EditWorkHealthRider",
        component: () => import("../views/HealthRider/ManageWork.vue"),
        props: true,
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/applicant",
    name: "",
    component: () => import("../layout/Main.vue"),
    children: [
      {
        path: "/",
        name: "Applicant",
        component: () => import("../views/Applicant.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/all_alert",
    name: "",
    component: () => {
      const refCode = localStorage.getItem("refcode");
      if (refCode === "moph") {
        return import("../layout/MainMoph.vue");
      } else {
        return import("../layout/Main.vue");
      }
    },
    children: [
      {
        path: "/",
        name: "AllAlert",
        component: () => import("../views/AlertList.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/package",
    name: "",
    component: NavbarPageComponent,
    children: [
      {
        path: "/",
        name: "PackageList",
        component: () => import("../views/Package/PackageList.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "request",
        name: "RequestAQuote",
        component: () => import("../views/Package/RequestAQuote.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      title: metatitle,
      icon: metalogo,
    },
  },
  // {
  //   path: "/talentsearch",
  //   name: "",
  //   component: () => import("../layout/Main-Recruiter.vue"),
  //   children: [
  //     {
  //       path: "/",
  //       name: "TalentSearch",
  //       component: () => import('../views/TalentSearch/SearchPage.vue'),
  //       meta: {
  //         title: metatitle,
  //         icon: metalogo,
  //       },
  //     },
  //     {
  //       path: "detail",
  //       name: "DetailCandidate",
  //       component: () => import('../views/TalentSearch/PreviewDetailCandidate.vue'),
  //       meta: {
  //         title: metatitle,
  //         icon: metalogo,
  //       },
  //     },
  //     {
  //       path: "detail/applicant",
  //       name: "ApplicantCandidateTalent",
  //       component: () => import('../views/TalentSearch/ApplicantList.vue'),
  //       meta: {
  //         title: metatitle,
  //         icon: metalogo,
  //       },
  //     },
  //   ],
  //   meta: {
  //     requiresAuth: true,
  //       title: metatitle,
  //       icon: metalogo,
  //     },
  // },
  {
    path: "/talentsearch",
    name: "",
    component: () => {
      const refCode = localStorage.getItem("refcode");
      if (refCode === "moph") {
        return import("../layout/MainMoph.vue");
      } else {
        return import("../layout/Main.vue");
      }
    },
    children: [
      {
        path: "/",
        name: "TalentSearch",
        component: () => {
          if (process.env.VUE_APP_USE_THEME === "NIEMS_ADMIN") {
            return import("../views/TalentSearch (Temporary)/MemberDetail.vue");
          }
          return refCode === "moph"
            ? import("../views/TalentSearchMoph/SearchPage.vue")
            : import("../views/TalentSearch (Temporary)/SearchPage.vue");
        },
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "detail",
        name: "DetailCandidate",
        component: () => {
          return refCode === "moph"
            ? import("../views/TalentSearchMoph/PreviewDetailCandidate.vue")
            : THEME == "NIEMS_ADMIN"
            ? import(
                "../views/TalentSearch (Temporary)/PreviewDetailMember.vue"
              )
            : import(
                "../views/TalentSearch (Temporary)/PreviewDetailCandidate.vue"
              );
        },
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "request",
        name: "RequestAQuoteTalent",
        component: () => import("../views/Package/RequestAQuote.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "detail/request",
        name: "RequestAQuoteCandidate",
        component: () => import("../views/Package/RequestAQuote.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },

  {
    path: "/managemembernumber",
    name: "",
    component: () => import("../layout/Main.vue"),
    children: [
      {
        path: "/",
        name: "ManageMemberNumber",
        component: () => import("../views/Niems/manageMemberNumber.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },

  {
    path: "/jobfair_booking",
    name: "jobfair",
    component: () => import("../layout/Main.vue"),
    children: [
      {
        path: "/",
        name: "bookingList",
        component: () => import("../views/UtccJobfair/BookingList.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "candidate_profile",
        name: "book-candidateProfile",
        component: () => import("../views/UtccJobfair/CandidateProfile.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },

  {
    path: "/job-scoring",
    name: "JobScoring",
    component: () => import("../layout/MainMoph.vue"),
    children: [
      {
        path: "/",
        name: "JobScoring",
        component: () => import("../views/JobScoring/JobScoring.vue"),
      },
    ],
  },
  {
    path: "/getcode",
    name: "ClickGetCode",
    component: () => import("../views/Applicant.vue"),
    // children: [
    //   {
    //     path: "/",
    //     name: "GetCode",
    //     component: () => import("../views/GetCode.vue"),
    //   },
    // ],
  },
  {
    path: "/togetcode",
    name: "GetCode",
    component: () => import("../views/GetCode.vue"),
    props: (route) => ({ code: route.query.code }),
    // children: [
    //   {
    //     path: "/",
    //     name: "GetCode",
    //     component: () => import("../views/GetCode.vue"),
    //   },
    // ],
  },

  // Admin Page
  {
    path: "/dashboard",
    name: "",
    component: () => import("../layout/Main-Admin.vue"),
    children: [
      {
        path: "overview",
        name: "Dashboard",
        component: () => import("../views/Admin/Dashboard.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "emp",
        name: "DashboardEmployer",
        component: () => import("../views/Admin/Dashboard.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "seeker",
        name: "DashboardSeeker",
        component: () => import("../views/Admin/Dashboard.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  // Approve Receipt
  {
    path: "/approve-receipt",
    name: "",
    component: () => {
      const refCode = localStorage.getItem("refcode");
      if (refCode === "moph") {
        return import("../layout/MainMoph.vue");
      } else {
        return import("../layout/Main.vue");
      }
    },
    children: [
      {
        path: "",
        name: "ApproveReceipt",
        component: () => import("../views/ApproveReceipt/ApproveReceipt.vue"),
      },
      {
        path: "detail/:id",
        name: "ApproveReceiptDetail",
        component: () =>
          import("../views/ApproveReceipt/ApproveReceiptDetail.vue"),
      },
    ],
    meta: {
      title: metatitle,
      icon: metalogo,
    },
  },

  // User Manual
  {
    path: "/user-manual",
    name: "",
    component: () => {
      const refCode = localStorage.getItem("refcode");
      if (refCode === "moph") {
        return import("../layout/MainMoph.vue");
      } else {
        return import("../layout/Main.vue");
      }
    },
    children: [
      {
        path: "",
        name: "ApproveReceipt",
        component: () => import("../views/UserManual/UserManual.vue"),
      },
    ],
    meta: {
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/approve",
    name: "",
    component: () => import("../layout/Main-Admin.vue"),
    children: [
      {
        path: "/",
        name: "Approve",
        component: () => import("../views/Admin/Approve.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "preview",
        name: "ApprovePreview",
        component: () => import("../views/Admin/ApproveDetail.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/job/manage",
    name: "JobManage",
    component: () => import("../layout/Main-Admin-KKU.vue"),
    // component: () => import("../layout/Main.vue"),
    children: [
      {
        path: "",
        name: "Approve",
        component: () => import("../views/AdminKKU/ApproveKKU.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "preview",
        name: "ApprovePreview",
        component: () => import("../views/AdminKKU/ApproveDetailKKU.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/jobtracking",
    name: "",
    component: () => import("../layout/Main-Admin.vue"),
    children: [
      {
        path: "/",
        name: "JobTracking",
        component: () => import("../views/Admin/JobTracking.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "jobonbusiness",
        name: "JobTrackingPreview",
        component: () => import("../views/Admin/JobonBusiness.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "previewjobtracking",
        name: "JobTrackingPreviewJob",
        component: () => import("../components/Admin/PreviewJob.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "tablejobapplicant",
        name: "TableJobApplicant",
        component: () =>
          import("../components/Admin/TablePreviewApplicant.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "resume",
        name: "AdminViewResumeApplicant",
        component: () => import("../views/Work/DialogResumeApplicant.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/refcode",
    name: "",
    component: () => import("../layout/Main-Admin.vue"),
    children: [
      {
        path: "/",
        name: "ManageRefCode",
        component: () => import("../views/Admin/RefCode.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/new-dashboard",
    name: "",
    component: () => import("../layout/Main-Admin.vue"),
    children: [
      {
        path: "/",
        name: "ManageNewDashboard",
        component: () => import("../views/Admin/NewDashboard.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/moph-dashboard",
    name: "",
    // component: () => import("../layout/Main-Admin-Moph.vue"),
    component: () => import("../layout/MainMoph.vue"),
    children: [
      {
        path: "/",
        name: "ManageMophDashboard",
        component: () => import("../views/Admin/MophDashboard.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/managepackage",
    name: "",
    component: () => import("../layout/Main-Admin.vue"),
    children: [
      {
        path: "/",
        name: "ManagePackage",
        component: () => import("../views/Admin/Package/Package.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "add",
        name: "AddPackage",
        component: () => import("../views/Admin/Package/PackageForm.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "edit",
        name: "EditPackage",
        component: () => import("../views/Admin/Package/PackageForm.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/managecredit",
    name: "",
    component: () => import("../layout/Main-Admin.vue"),
    children: [
      {
        path: "/",
        name: "ManageCredit",
        component: () => import("../views/Admin/Credit/Credit.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "detail",
        name: "ManageCreditDetail",
        component: () => import("../views/Admin/Credit/CreditDetail.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/new-managecredit",
    name: "",
    component: () => import("../layout/Main-Admin.vue"),
    children: [
      {
        path: "/",
        name: "ManagePackage",
        component: () => import("../views/Admin/ManageCredit/ManageCredit.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "company",
        name: "CompanyDetail",
        component: () =>
          import("../views/Admin/ManageCredit/CompanyDetail.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },

  // Super Admin Page
  {
    path: "/manage_user",
    name: "",
    component: () => import("../layout/Main.vue"),
    children: [
      {
        path: "",
        name: "ManageUser",
        component: () => import("../views/SuperAdmin/ManageUser.vue"),
      },
      {
        path: "overview",
        name: "Overview",
        component: () => import("../views/Admin/Dashboard.vue"),
      },
      {
        path: "approve",
        name: "Approve",
        component: () => import("../views/Admin/Approve.vue"),
      },
      {
        path: "preview",
        name: "ApprovePreview",
        component: () => import("../views/Admin/ApproveDetail.vue"),
      },
      {
        path: "jobtracking",
        name: "JobTracking",
        component: () => import("../views/Admin/JobTracking.vue"),
      },
      {
        path: "jobonbusiness",
        name: "JobTrackingPreview",
        component: () => import("../views/Admin/JobonBusiness.vue"),
      },
      {
        path: "previewjobtracking",
        name: "JobTrackingPreviewJob",
        component: () => import("../components/Admin/PreviewJob.vue"),
      },
      {
        path: "tablejobapplicant",
        name: "TableJobApplicant",
        component: () =>
          import("../components/Admin/TablePreviewApplicant.vue"),
      },
      {
        path: "resume",
        name: "AdminViewResumeApplicant",
        component: () => import("../views/Work/DialogResumeApplicant.vue"),
      },
      {
        path: "managepackage",
        name: "ManagePackage",
        component: () => import("../views/Admin/Package/Package.vue"),
      },
      {
        path: "add_package",
        name: "AddPackage",
        component: () => import("../views/Admin/Package/PackageForm.vue"),
      },
      {
        path: "edit_package",
        name: "EditPackage",
        component: () => import("../views/Admin/Package/PackageForm.vue"),
      },
      {
        path: "emp",
        name: "Emp",
        component: () => import("../views/Admin/Dashboard.vue"),
      },
      {
        path: "seeker",
        name: "Seeker",
        component: () => import("../views/Admin/Dashboard.vue"),
      },
      {
        path: "refcode",
        name: "RefCode",
        component: () => import("../views/Admin/RefCode.vue"),
      },
      {
        path: "managecredit",
        name: "",
        component: () => import("../views/Admin/Credit/Credit.vue"),
      },
      {
        path: "detail",
        name: "ManageCreditDetail",
        component: () => import("../views/Admin/Credit/CreditDetail.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/403",
    name: "403",
    component: NavbarPageComponent,
    children: [
      {
        path: "",
        name: "ForbiddenNiems",
        component: () => {
          if (process.env.VUE_APP_USE_THEME === "KKU_ADMIN") {
            return import("../views/Errors/ForbiddenKKU.vue");
          } else if (process.env.VUE_APP_USE_THEME === "SPU_ADMIN") {
            return import("../views/Errors/ForbiddenNiems.vue");
          } else if (process.env.VUE_APP_USE_THEME === "NIEMS_TRAINING_ADMIN") {
            return import("../views/Errors/ForbiddenTraining.vue");
          }
        },
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
  },
  {
    path: "/training-program",
    name: "",
    component: () => import("../layout/Main-Admin-Trainer.vue"),
    children: [
      {
        path: "",
        name: "TrainingProgram",
        component: () =>
          import("../views/ProfessorNiems/TrainingProgram/TrainingProgram.vue"),
        meta: {
          requiresAuth: true,
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "create",
        name: "ManageProgram",
        component: () =>
          import("../views/ProfessorNiems/TrainingProgram/ManageProgram.vue"),
        meta: {
          requiresAuth: true,
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "edit/:biz_recruit_id",
        name: "ManageEditProgram",
        component: () =>
          import("../views/ProfessorNiems/TrainingProgram/ManageProgram.vue"),
        props: true,
        meta: {
          requiresAuth: true,
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: ":biz_recruit_id",
        name: "ProgramDetails",
        component: () =>
          import("../views/ProfessorNiems/TrainingProgram/ProgramDetails.vue"),
        props: true,
        meta: {
          requiresAuth: true,
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
  },
  {
    path: "/trainer",
    name: "",
    component: () => import("../layout/Main-Admin-Trainer.vue"),
    children: [
      {
        path: "",
        name: "TrainerEvaluation",
        component: () =>
          import("../views/ProfessorNiems/TrainerEvaluation/CourseTrainer.vue"),
        meta: {
          requiresAuth: true,
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: ":biz_recruit_id",
        name: "ManageTrainer",
        component: () =>
          import("../views/ProfessorNiems/TrainerEvaluation/ManageTrainer.vue"),
        props: true,
        meta: {
          requiresAuth: true,
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "manage-trainer",
        name: "ManageTrainer",
        component: () =>
          import("../views/ProfessorNiems/TrainerEvaluation/ManageTrainer.vue"),
        meta: {
          requiresAuth: true,
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: "trainer-detail/:app_id?",
        name: "TrainerDetail",
        component: () =>
          import("../views/ProfessorNiems/TrainerEvaluation/TrainerDetail.vue"),
        props: (route) => ({
          app_id: route.params.app_id || route.query.app_id,
        }),
        meta: {
          requiresAuth: true,
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
  },
  {
    path: "/teacher-program",
    name: "",
    component: () => import("../layout/Main-Admin-Trainer.vue"),
    children: [
      {
        path: "",
        name: "TeacherProgram",
        component: () =>
          import("../views/ProfessorNiems/Teacher/TeacherProgram.vue"),
        meta: {
          requiresAuth: true,
          title: metatitle,
          icon: metalogo,
        },
      },
      {
        path: ":biz_recruit_id",
        name: "ProgramTeacherDetails",
        component: () =>
          import("../views/ProfessorNiems/Teacher/ProgramDetails.vue"),
        props: true,
        meta: {
          requiresAuth: true,
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/application_information",
    name: "",
    component: () => import("../layout/Main-Admin-Trainer.vue"),
    children: [
      {
        path: ":appId",
        name: "ApplicationInformation",
        component: () =>
          import("../views/ProfessorNiems/ApplicationInformationPage.vue"),
        props: true,
        meta: {
          requiresAuth: true,
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
  },
  {
    path: "/all_alert_training",
    name: "",
    component: () => import("../layout/Main-Admin-Trainer.vue"),
    children: [
      {
        path: "/",
        name: "AllAlert",
        component: () => import("../views/AlertList.vue"),
        meta: {
          title: metatitle,
          icon: metalogo,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/signature",
    name: "",
    component: () => import("../layout/Main-Admin-Trainer.vue"),
    children: [
      {
        path: "",
        name: "SignaturePage",
        component: () =>
          import("../views/ProfessorNiems/ManageSignatures/SignaturePage.vue"),
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
  {
    path: "/payment",
    name: "",
    component: () => import("../layout/Main-Admin-Trainer.vue"),
    children: [
      {
        path: "",
        name: "VerifyPayment",
        component: () =>
          import("../views/ProfessorNiems/Payment/VerifyPayment.vue"),
      },
    ],
    meta: {
      requiresAuth: true,
      title: metatitle,
      icon: metalogo,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  const isLoggedIn = store.getters.isLoggedIn || token;
  const themes_data = store.getters.themes;

  if (to.meta.title || themes_data.footer_data) {
    document.title = themes_data.footer_data.meta_title || to.meta.title;
  }
  if (to.meta.icon) {
    const link = document.querySelector("link[rel~='icon']");
    if (link) {
      link.href = to.meta.icon;
    } else {
      const newLink = document.createElement("link");
      newLink.rel = "icon";
      newLink.href = to.meta.icon;
      document.head.appendChild(newLink);
    }
  }

  if (to.path !== "/") {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      if (isLoggedIn) {
        // เพิ่มเงื่อนไขสำหรับ refCode == "niems"
        if (
          refCode === "NIEMS_ADMIN" &&
          !to.path.startsWith("/talentSearch") &&
          !to.path.startsWith("/managemembernumber")
        ) {
          return next("/");
        }

        next();
      } else if (to.path == "/home") {
        return next("/home");
      } else {
        next("/");
      }
    } else if (
      [
        "adminRef",
        "landing",
        "oauth_provider",
        "oauth_login_kku",
        "oauth_logout_kku",
        "oauth_login_training",
        "surveyRef",
        "register",
        "getcode",
        "togetcode",
        "terms",
        "policy",
        "imageandvideo",
        "edit_news",
        "profile_moph",
        "approve-receipt",
        "user-manual",
        "job-scoring",
        "403",
      ].includes(to.path.substring(1).split("/")[0]) ||
      ["LandingPage", "PackageList", "RequestAQuote"].includes(to.name)
    ) {
      next();
    } else {
      next("/");
    }
  } else if (isLoggedIn) {
    if (refCode === "NIEMS_ADMIN") {
      return next("/talentsearch");
    }
    if (to.path !== "/home") {
      return next("/home");
    }
  } else {
    next();
  }
});

router.afterEach(() => {
  setTimeout(() => window.scrollTo(0, 0), 600);
});

export default router;
